var __jsx = React.createElement;
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadExampleExperiments } from 'redux/actions/experiments';
import RepositoryTable from 'components/repository/RepositoryTable';
var RepositoryPage = function RepositoryPage() {
  var dispatch = useDispatch();
  var user = useSelector(function (state) {
    return state.user.current;
  });
  var exampleExperiments = useSelector(function (state) {
    var _state$experiments$me;
    return (_state$experiments$me = state.experiments.meta) === null || _state$experiments$me === void 0 ? void 0 : _state$experiments$me.exampleExperiments;
  });
  useEffect(function () {
    dispatch(loadExampleExperiments());
  }, [user]);
  return __jsx(RepositoryTable, {
    data: exampleExperiments
  });
};
export default RepositoryPage;